import { useState } from 'react';
import { useAtomValue } from 'jotai';
import { BlockButton } from '@/components/BlockButton';
import usePostJobChangeProcess from '../../api/usePostJobChangeProcess';
import { showErrorToast, showSuccessToast } from '../../lib/toast';
import { currentSelectjobChangeProcessAtom } from '../../atoms/jobChangeProcess';

type Props = {
  jobChangeProcessId: number;
  close: () => void;
  jobchangeProcessesRefetch: () => Promise<void>;
};
export default function StatusOfferModalContents({
  jobChangeProcessId,
  close,
  jobchangeProcessesRefetch,
}: Props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const { mutateAsync } = usePostJobChangeProcess();

  const currentJobChangeProcess = useAtomValue(currentSelectjobChangeProcessAtom);
  const candidateName = currentJobChangeProcess?.candidate_profile?.name ?? '';
  const companyName = currentJobChangeProcess?.company?.name ?? '';

  const onSubmit = async () => {
    setIsSubmit(true);
    try {
      await mutateAsync({ jobChangeProcessId, status: 'offer' });
      showSuccessToast('ステータスを変更しました');
    } catch (error) {
      showErrorToast('ステータスの変更に失敗しました');
    } finally {
      await jobchangeProcessesRefetch();
      setIsSubmit(false);
      close();
    }
  };

  return (
    <div className="w-[640px] bg-white">
      <div className="px-6 py-4">
        <p className="text-base font-bold">
          {candidateName} × {companyName}
        </p>
      </div>
      <div className="border-y border-solid border-border px-6 py-4">
        <p className="text-base">ステータスを「内定」に変更しますか？</p>
      </div>
      <div className="flex justify-end gap-4 px-6 py-4">
        <div className="w-[94px]">
          <BlockButton
            disabled={isSubmit}
            colorType="white"
            type="button"
            text="キャンセル"
            onClick={close}
          />
        </div>
        <div className="w-[94px]">
          <BlockButton disabled={isSubmit} type="button" text="内定に変更" onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
}
